import { render } from "./UserProjectCard.vue?vue&type=template&id=2d9ae43c&scoped=true"
import script from "./UserProjectCard.vue?vue&type=script&lang=js"
export * from "./UserProjectCard.vue?vue&type=script&lang=js"

import "./UserProjectCard.vue?vue&type=style&index=0&id=2d9ae43c&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9ae43c"]])

export default __exports__